import React, { type FunctionComponent, useContext } from 'react';

import type { JobDetails } from '../../sdk';

export const JobDetailsContext = React.createContext<JobDetails | undefined>(
  undefined,
);

interface Props {
  jobDetails: JobDetails | undefined;
  children?: React.ReactNode;
}

export const JobDetailsProvider: FunctionComponent<Props> = ({
  jobDetails,
  children,
}) => (
  <JobDetailsContext.Provider value={jobDetails}>
    {children}
  </JobDetailsContext.Provider>
);

export const useJobDetails = (): JobDetails | undefined => {
  const context = useContext(JobDetailsContext);
  return context;
};
